//基本路径
export let baseUrl='';
export let clooudBaseUrl_login='';//云平台登录页面
export let myBaseUrl='';
export let baseAddressUrl='';//浏览器地址栏页面基础路径

export let clooudBaseUrl='';//云平台接口地址
if(process.env.NODE_ENV == 'production'){//生产环境
	if(process.env.VUE_APP_NAME=="build"){
		clooudBaseUrl_login='http://www.valuetek.com.cn/cas';//云平台登录页面
		clooudBaseUrl='';//云平台接口地址

        baseAddressUrl='http://www.valuetek.com.cn';//浏览器地址栏页面基础路径
		baseUrl='';
		myBaseUrl = 'http://www.valuetek.com.cn/cmsApi'
	}else{//测试环境：alpha
		clooudBaseUrl_login='http://www.valuetek.com.cn/cas';//云平台登录页面
		clooudBaseUrl='';//云平台接口地址

        baseAddressUrl='http://www.valuetek.com.cn';//浏览器地址栏页面基础路径
		baseUrl='';
		myBaseUrl = 'http://www.valuetek.com.cn/cmsApi'
	}
}else{//开发环境，process.env.NODE_ENV == 'development'
	clooudBaseUrl_login='http://www.valuetek.com.cn/cas';//云平台登录页面
	clooudBaseUrl='';//云平台接口地址

    baseAddressUrl='http://www.valuetek.com.cn';//浏览器地址栏页面基础路径
	baseUrl='';
	// baseUrl='http://192.168.0.2:8604';//唐
	myBaseUrl = 'http://www.valuetek.com.cn/cmsApi';
}
//上传文件的地址
export let fileUploadUrl = baseUrl+"/api/file/upload";
//下载文件的地址
export let fileDownloadUrl = baseUrl+"/api/file/download";
//接口
export const httpUrl={
	//========================页面地址==========================
	clooudLogin:clooudBaseUrl_login,//云平台CAS登录地址
	//========================页面地址==========================

	//========================通用==========================
	fileUploadUrl : fileUploadUrl,//上传文件
	downloadWorks:baseUrl+"/api/works/downloadWorks",//下载作品附件
	getNowTime:baseUrl+"/api/activity/getNowTime",//获取服务器当前时间戳
	//========================通用==========================
    
	//========================用户信息==========================
	getTokenUser:clooudBaseUrl+"/yjpub/getTokenUser.do",//云平台用户信息
	exitLogin: clooudBaseUrl + "/exit.do",//退出
	getMenus: baseUrl + "/api/user/getMenus",//管理员菜单
	//========================用户信息==========================


	//=========================行业新闻============================
	getContentList: myBaseUrl + '/api/content/getContentList',//获取内容列表
	getContentById: myBaseUrl + '/api/content/getContentById',//获取内容详情
  	//=========================行业新闻============================
}
